import { useFormikContext } from 'formik';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import { type EventDataFragment } from '../../../../api/fragments';
import { ApplicationKind } from '../../../../api/types';
import Chatbot from '../../../../components/Chatbot';
import useTranslatedString from '../../../../utilities/useTranslatedString';
import { type LocalVariant } from '../../../../utilities/useVehicleOptions';
import { type ApplicantFormValues } from './shared';

const ChatbotDiv = styled.div`
    position: fixed;
    bottom: 120px;
    right: 24px;
`;

type EventApplicationModule = Extract<EventDataFragment, { __typename: 'Event' }>['module'];

type LiveChatProps = {
    variants: LocalVariant[];
    chatSetting: Extract<EventApplicationModule, { __typename: 'EventApplicationModule' }>['liveChatSetting'];
};

const LiveChat = ({ chatSetting, variants }: LiveChatProps) => {
    const { values } = useFormikContext<ApplicantFormValues>();

    const translatedString = useTranslatedString();

    const [modelName, variantName] = useMemo(() => {
        const vehicle = variants.find(variant => variant.model.id === values.vehicleInterest.model);
        const variant = variants.find(variant => variant.id === values.vehicleInterest.variant);

        return vehicle
            ? [translatedString(vehicle?.model?.name), translatedString(variant?.name)]
            : [undefined, undefined];
    }, [translatedString, values.vehicleInterest.model, values.vehicleInterest.variant, variants]);

    return (
        <ChatbotDiv>
            <Chatbot
                applicationKind={ApplicationKind.Event}
                chatSetting={{
                    ...chatSetting,
                    modelName,
                    variantName,
                }}
            />
        </ChatbotDiv>
    );
};

export default LiveChat;
